// EmptyState primitive — Card 톤 + IconCircle + 제목 + 설명 + optional CTA.
// 시안엔 명시 컴포넌트 없음. design/v3/Primitives.jsx Card + AlertBanner 의 IconCircle 패턴
// (Primitives.jsx:137 의 width:20,height:20 borderRadius:999 background:s.icon) 차용 → 더 큰 사이즈로.

import type { CSSProperties, ReactNode } from 'react';

import { Icon } from './icons';

export interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  style?: CSSProperties;
}

export function EmptyState({ icon, title, description, action, style }: EmptyStateProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'var(--space-3)',
        padding: 'var(--space-10) var(--space-6)',
        textAlign: 'center',
        background: 'var(--bg-surface)',
        border: '1px solid var(--border-weak)',
        borderRadius: 'var(--radius-lg)',
        ...style,
      }}
    >
      {icon && (
        <span
          style={{
            width: 48,
            height: 48,
            borderRadius: 'var(--radius-full)',
            background: 'var(--bg-subtle)',
            border: '1px solid var(--border-weak)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon name={icon} size={22} color="var(--fg-3)" />
        </span>
      )}
      <div
        style={{
          fontSize: 'var(--text-md)',
          fontWeight: 600,
          color: 'var(--fg-1)',
          letterSpacing: 'var(--tracking-tight)',
        }}
      >
        {title}
      </div>
      {description && (
        <div
          style={{
            fontSize: 13,
            color: 'var(--fg-3)',
            lineHeight: 'var(--lh-body)',
            maxWidth: 360,
          }}
        >
          {description}
        </div>
      )}
      {action && <div style={{ marginTop: 'var(--space-2)' }}>{action}</div>}
    </div>
  );
}
